<div class="phone-input">
  <p-select
    class="phone-input__country"
    size="large"
    appendTo="body"
    optionValue="iso2"
    [options]="countryOptions"
    [filter]="true"
    filterBy="iso2,dialCode"
    [virtualScroll]="true"
    [virtualScrollItemSize]="40"
    [ngModel]="countryIso2()"
    [invalid]="invalid()"
    [disabled]="disabled()"
    panelStyleClass="phone-input__country-panel"
    (ngModelChange)="onCountryChange($event)"
  >
    <ng-template let-opt pTemplate="selectedItem">
      @if (opt) {
        <span class="phone-input__selected">
          <span class="phone-input__flag fi fi-{{ opt.iso2.toLowerCase() }}"></span>
          <span class="phone-input__dial">+{{ opt.dialCode }}</span>
        </span>
      }
    </ng-template>
    <ng-template let-opt pTemplate="item">
      <span class="phone-input__option">
        <span class="phone-input__flag fi fi-{{ opt.iso2.toLowerCase() }}"></span>
        <span class="phone-input__iso">{{ opt.iso2 }}</span>
        <span class="phone-input__dial phone-input__dial--end">+{{ opt.dialCode }}</span>
      </span>
    </ng-template>
    <ng-template let-options="options" pTemplate="filter">
      <p-iconfield class="phone-input__filter" iconPosition="left">
        <p-inputicon styleClass="pi pi-search" />
        <input type="text" pInputText pSize="large" (input)="options.filter($event)" />
      </p-iconfield>
    </ng-template>
  </p-select>

  <input
    #numberInput
    pInputText
    type="tel"
    inputmode="numeric"
    class="phone-input__number"
    pSize="large"
    [invalid]="invalid()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    (input)="onNumberInput(numberInput)"
    (blur)="markTouched()"
  />
</div>
